var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-3-copy-2",
    fill: "#656565",
    d: "M1150.01 461.006c1.11 0 2 .895 2 2 0 1.104-.89 2-2 2-1.11 0-2-.896-2-2 0-1.105.89-2 2-2zm0-6c1.11 0 2 .895 2 2 0 1.104-.89 2-2 2-1.11 0-2-.896-2-2 0-1.105.89-2 2-2zm0-6c1.11 0 2 .895 2 2 0 1.104-.89 2-2 2-1.11 0-2-.896-2-2 0-1.105.89-2 2-2z",
    transform: "translate(-1134.01 -441.006)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownMenu);
export default __webpack_public_path__ + "static/media/dropdown-menu.53367342478b427cd5e6e443c5a3d62c.svg";
export { ForwardRef as ReactComponent };